import { ToastProgrammatic as Toast } from "buefy";

export function warning(message: string) {
  Toast.open({
    duration: 4000,
    message,
    position: "is-bottom",
    type: "is-warning",
  });
}

export function error(message: string) {
  Toast.open({
    duration: 6000,
    message,
    position: "is-bottom",
    type: "is-danger",
  });
}

export function success(message: string) {
  Toast.open({
    duration: 2000,
    message,
    position: "is-bottom",
    type: "is-success",
  });
}

export function info(message: string) {
  Toast.open({
    duration: 2000,
    message,
    position: "is-bottom",
    type: "is-info",
  });
}

export default {
  error,
  success,
  warning,
  info,
};
